import React, { useState } from "react";
import {
  User,
  Calendar,
  Clock,
  Settings,
  BookOpen,
  Droplet,
  Layers,
  SlidersHorizontal,
  Mail,
  Palette,
  HardDrive,
  Sparkles,
  ChevronDown,
  ChevronRight,
  ShieldCheck,
  Type,
  BarChart3,
} from "lucide-react";

function Sidebar({ currentTab, onTabChange, open, onClose, colorSidebar = "#2563eb" }) {
  const menu = [
    { id: "usuarios", name: "Gestionar Usuarios", icon: <User size={20} /> },
    { id: "citas", name: "Gestionar Citas", icon: <Calendar size={20} /> },
    { id: "estadisticasCDA", name: "📊 Estadísticas CDA", icon: <BarChart3 size={20} /> },
    { id: "horarios", name: "Gestionar Horarios", icon: <Clock size={20} /> },
    { id: "servicios", name: "Gestionar Servicios", icon: <Settings size={20} /> },
    { id: "grados", name: "Gestionar Grados", icon: <BookOpen size={20} /> },
    { id: "etiquetasDocentes", name: "Etiquetas Docentes", icon: <User size={20} /> },
    { id: "configuracionesHorarios", name: "⚙️ Configuraciones", icon: <SlidersHorizontal size={20} /> },
    { id: "resumenCitas", name: "📋 Resumen de Citas", icon: <Mail size={20} /> },
    { id: "respaldos", name: "💾 Respaldos", icon: <HardDrive size={20} /> },
    { id: "modoSeguridad", name: "🔒 Modo de Seguridad", icon: <ShieldCheck size={20} /> },
  ];

  const menuColores = [
    { id: "temas", name: "🎨 Temas Predefinidos", icon: <Sparkles size={18} /> },
    { id: "colorFondo", name: "Color de Fondo", icon: <Droplet size={18} /> },
    { id: "colorServicios", name: "Fondos por Servicio", icon: <Layers size={18} /> },
    { id: "coloresSitio", name: "Colores del Sitio", icon: <Droplet size={18} /> },
    { id: "tituloLogin", name: "Título del Login", icon: <Type size={18} /> },
  ];

  const tabsColores = menuColores.map((m) => m.id);
  const [coloresAbierto, setColoresAbierto] = useState(tabsColores.includes(currentTab));

  return (
    <>
      {/* FONDO OSCURO (solo móvil, cuando el menú está abierto) */}
      {open && (
        <div
          onClick={onClose}
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
        />
      )}

      <div
        className={`
          fixed md:static top-0 left-0 h-screen z-50
          w-64 text-white flex flex-col
          transform transition-transform duration-200
          ${open ? "translate-x-0" : "-translate-x-full"}
          md:translate-x-0
        `}
        style={{ backgroundColor: colorSidebar }}
      >
        <div
          className="p-6 text-2xl font-bold"
          style={{ borderBottom: "1px solid rgba(255,255,255,0.25)" }}
        >
          Admin Panel
        </div>

        <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
          {menu.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                onTabChange(item.id);
                onClose && onClose();
              }}
              className="flex items-center gap-3 w-full p-3 rounded-xl transition hover:bg-white/10"
              style={{
                backgroundColor: currentTab === item.id ? "rgba(255,255,255,0.22)" : "transparent",
              }}
            >
              {item.icon}
              <span>{item.name}</span>
            </button>
          ))}

          {/* ================= PERSONALIZAR COLORES (desplegable) ================= */}
          <button
            onClick={() => setColoresAbierto(!coloresAbierto)}
            className="flex items-center justify-between w-full p-3 rounded-xl transition hover:bg-white/10"
          >
            <span className="flex items-center gap-3">
              <Palette size={20} />
              🎨 Personalizar Colores
            </span>
            {coloresAbierto ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
          </button>

          {coloresAbierto && (
            <div className="flex flex-col gap-1 pl-4">
              {menuColores.map((item) => (
                <button
                  key={item.id}
                  onClick={() => {
                    onTabChange(item.id);
                    onClose && onClose();
                  }}
                  className="flex items-center gap-3 w-full p-2.5 rounded-lg text-sm transition hover:bg-white/10"
                  style={{
                    backgroundColor: currentTab === item.id ? "rgba(255,255,255,0.22)" : "transparent",
                  }}
                >
                  {item.icon}
                  <span>{item.name}</span>
                </button>
              ))}
            </div>
          )}
        </nav>
      </div>
    </>
  );
}

export default Sidebar;

